import { Component } from '@opten/compiler/metadata/component';

import '../countdown-media/simplycountdown-fixed.js';

@Component({ className: 'js-countdown-media', observe: true })
export class CountdownMediaComponent{
	countdownElement: HTMLElement;
	targetToLoad: string;
    language: string;

	constructor(private element: HTMLElement) {
		this.countdownElement = element.querySelector('.js-countdown-media-countdown');
		this.targetToLoad = element.getAttribute('data-countdown-media-to-load');
		var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
        }
		this.initCountdown();
	}
	initCountdown() {
		if(this.countdownElement){
			const year = parseInt(this.countdownElement.getAttribute('data-year'),10);
			const month = parseInt(this.countdownElement.getAttribute('data-month'),10);
			const day = parseInt(this.countdownElement.getAttribute('data-day'),10);
			const hour = parseInt(this.countdownElement.getAttribute('data-hour'),10);
			const minute = parseInt(this.countdownElement.getAttribute('data-minute'),10);
			const second = parseInt(this.countdownElement.getAttribute('data-second'),10);

			const dayTranslationSingular = this.countdownElement.getAttribute('data-day-translation-singular');
			const hourTranslationSingular = this.countdownElement.getAttribute('data-hour-translation-singular');
			const minuteTranslationSingular = this.countdownElement.getAttribute('data-minute-translation-singular');
			const secondTranslationSingular = this.countdownElement.getAttribute('data-second-translation-singular');
			const dayTranslationPlural = this.countdownElement.getAttribute('data-day-translation-plural');
			const hourTranslationPlural = this.countdownElement.getAttribute('data-hour-translation-plural');
			const minuteTranslationPlural = this.countdownElement.getAttribute('data-minute-translation-plural');
			const secondTranslationPlural = this.countdownElement.getAttribute('data-second-translation-plural');

			simplyCountdown(this.countdownElement, {
				year: year, // required
				month: month, // required
				day: day, // required
				hours: hour, // Default is 0 [0-23] integer
				minutes: minute, // Default is 0 [0-59] integer
				seconds: second, // Default is 0 [0-59] integer
				words: { //words displayed into the countdown
					days: { singular: dayTranslationSingular, plural: dayTranslationPlural },
					hours: { singular: hourTranslationSingular, plural: hourTranslationPlural },
					minutes: { singular: minuteTranslationSingular, plural: minuteTranslationPlural },
					seconds: { singular: secondTranslationSingular, plural: secondTranslationPlural }
				},
				plural: true, //use plurals
				inline: false, //set to true to get an inline basic countdown like : 24 days, 4 hours, 2 minutes, 5 seconds
				inlineClass: 'simply-countdown-inline', //inline css span class in case of inline = true
				// in case of inline set to false
				enableUtc: false, //Use UTC or not - default : false
				onEnd: () => {
					fetch(this.targetToLoad, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
							'accept-language': this.language,
							// todo: why? if we change to a api controller we don't have this problem...
							'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
						},
						credentials: 'include'
					})
						.then(response => {
							const contentType = response.headers.get('content-type');
							if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
								return response.text();
							}
						})
						.then(data => {
							if (data != null && data.length > 0) {
								this.element.innerHTML = data;
							}
						});
				}, //Callback on countdown end, put your own function here
				refresh: 1000, // default refresh every 1s
				sectionClass: 'simply-section', //section css class
				amountClass: 'simply-amount', // amount css class
				wordClass: 'simply-word', // word css class
				zeroPad: false,
				countUp: false
		});
		}
	}
}
